import * as types from './mutation-types';

export default {
  [types.SET_IDENTIFIERS](state, payload) {
    state.osIdentifiers = payload;
  },
};
